import useSWR from 'swr'
import { client } from '@lib/api'

type KYCDetail = {
    kyc_user_uuid: string,
    sumsub_uuid: string,
    kyc_level: string,
    verified_items: {
        phone_number: boolean,
        email: boolean,
        id_card: boolean,
        selfie: boolean,
        source_of_wealth: boolean
    },
    phone_number: string,
    email: string,
    full_legal_name: string,
    review_status: string
}

const useKYCDetail = () => {
    const { data, isLoading, error } = useSWR(
        '/v2/wallet/kyc/my-detail', 
        client.doPost,
        {
            dedupingInterval: 10000 // 10 seconds
        }
    )

    const levelNumber: number = data?.kyc_level.match(/\d+/)?.[0] || 0

    return {
        data: data as KYCDetail | undefined,
        isLoading,
        error,
        levelNumber
    }
}

export default useKYCDetail